import * as React from "react";
import Grid from "@material-ui/core/Grid";
import CyLineChart from "../../../components/Charts/CyLineChart";
import Typography from "@material-ui/core/Typography";
import HighLevelDisclosure from "./HighLevelDisclosure";
import CyTotalIncomeChart from "../../../components/Charts/CyTotalIncomeChart";
import CurrencyNumber from "../../../components/UI/CurrencyNumber";

const StrategyPerformanceStats = (props) => {
  const {
    portfolio,
    baseChartData,
    annualWithdrawalChartData,
    totalWithdrawal,
    benchmarkName,
  } = props;
  const { name, metadata } = portfolio;

  return (
    <section
      className={"content"}
      data-toc={`Hypothetical Performance of Investment vs. Benchmark ${
        annualWithdrawalChartData ? "with Withdrawals" : ""
      }`}
    >
      <Grid container={true} spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h4">
            Cy Optimized Portfolio vs Benchmark{" "}
            {annualWithdrawalChartData ? "with Withdrawals" : ""}
          </Typography>
          <Typography variant="h5" gutterBottom={true}>
            Hypothetical Illustration
          </Typography>
          <Typography variant="h6" gutterBottom={true}>
            Investment Amount{" "}
            <CurrencyNumber value={metadata.initialInvestment} />
          </Typography>
        </Grid>
      </Grid>
      {baseChartData && (
        <Grid container={true} spacing={3} style={{ marginBottom: "0.2in" }}>
          <Grid item={true} xs={12}>
            <CyLineChart
              showTooltip={false}
              initialInvestment={metadata.initialInvestment}
              data={baseChartData}
              renderForPdfOutput={true}
              portfolioName={name}
              benchmarkName={benchmarkName}
            />
          </Grid>
        </Grid>
      )}
      {annualWithdrawalChartData && totalWithdrawal && (
        <Grid container={true} spacing={3}>
          <Grid item xs={12}>
            <CyTotalIncomeChart
              data={totalWithdrawal}
              renderForPdfOutput={true}
              initialInvestment={metadata.initialInvestment}
              annualWithdrawal={metadata.annualWithdrawal}
              strategyName={portfolio.cprRecommendation.displayName || ""}
              benchmarkName={benchmarkName}
            />
          </Grid>
          <Grid item={true} xs={12}>
            <CyLineChart
              data={annualWithdrawalChartData}
              showTooltip={false}
              initialInvestment={metadata.initialInvestment}
              withAnnualWithdrawal={true}
              renderForPdfOutput={true}
              portfolioName={name}
              benchmarkName={benchmarkName}
            />
          </Grid>
        </Grid>
      )}
      <HighLevelDisclosure
        includeTotalIncome={annualWithdrawalChartData}
        initialInvestment={metadata.initialInvestment}
      />
    </section>
  );
};


export default StrategyPerformanceStats;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/StrategyPerformanceChart.jsx